import { UpdatableItemManager, IUpdatableItem } from "../../../Utils/UpdatableItemManager";
import { ScorePopup } from "./ScorePopup";
import { Game, eFontAsset, eAudioAsset, eGameAPI, eAtlas_0 } from "../../../Game";
import { Score } from "../../../Utils/Score";
import { Gameplay } from "../../Gameplay";
import { Player } from "../Player/Player";
import { Wrapper as Gamee } from "../../../SDK/Gamee/GameeWrapper";
import { DebugOutput } from "../../../Utils/DebugOutput";
import { Tutorial } from "./Tutorial";
import { SoundManager } from "../../../Utils/SoundManager";
import { SaveState } from "../../../SaveState";
import { GameOver } from "./GameOver";
import { eAdMode, eAdState } from "../../../SDK/SDKBase";



export const enum eHUDState {
    tutorial,
    gameplay,
    gameOver,
}



export class HUD {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): HUD { return HUD._instance; }
    private static _instance: HUD;

    private _state: eHUDState;

    /**
     * (RO) pc.Entity se Screen komponentou pro zobrazeni informaci v HUDu
     */
    get screen(): pc.Entity { return this._screen; }
    private _screen: pc.Entity;

    /**
     * (RO) Element zobrazujici aktualni skore
     */
    get score(): pc.ElementComponent { return this._score.element; }
    private _score: pc.Entity;

    /**
     * Spravce vyskakujicich zprav se skore
     */
    private _scorePopups: UpdatableItemManager;

    /**
     * Tutorial
     */
    get tutorial(): Tutorial { return this._tutorial; }
    private _tutorial: Tutorial;

    /**
     * Tlacitko pro vypnuti/zapnuti zvuku
     */
    private _btnAudio: pc.Entity;

    /**
     * Tlacitko pro invite hracu
     */
    private _btnInvite: pc.Entity;

    /**
     * Obrazovka pro GameOver
     */
    private _gameOver: GameOver;

    //get debugOutput(): DebugOutput { return this._debugOutput; }
    //private _debugOutput: DebugOutput;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        HUD._instance = this;

        this._scorePopups = new UpdatableItemManager(1, true, (): IUpdatableItem => {
            return new ScorePopup();
        }, this);

        // 2D screen
        this._screen = new pc.Entity("hud");
        this._screen.addComponent(pc.eCompomentType.screen, {
            scaleMode: pc.SCALEMODE_BLEND,
            screenSpace: true,
            scaleBlend: Game.scale.maxWidth < Game.scale.maxHeight ? 0 : 1,
            referenceResolution: new pc.Vec2(Game.scale.minWidth, Game.scale.minHeight)
        });
        Game.app.root.addChild(this._screen);

        // Vykreslovani skore
        if (!Gamee.GAMEE) {
            this._score = new pc.Entity("");
            this._score.addComponent(pc.eCompomentType.element, {
                type: pc.ELEMENTTYPE_TEXT,
                anchor: [1, 1, 1, 1],
                pivot: [1, 1],
                fontSize: 48,
                fontAsset: Game.app.assets.find(eFontAsset.default, pc.eAssetType.font).id,
                autoWidth: true,
                autoHeight: true,
            });
            this._score.element.shadowColor.set(0, 0, 0, 1);
            this._score.element.shadowOffset.set(1, -1);
            this._score.setLocalPosition(-20, -20, 0);
            this._screen.addChild(this._score);

            Gameplay.instance.events.on(Score.EVENT_SCORE_CHANGE, (score: Score, value: number) => {
                this._score.element.text = value.toString();
            }, this);
        }

        // Tutorial
        this._tutorial = new Tutorial();

        if (Game.API == eGameAPI.OK || Game.API == eGameAPI.VK) {
            // GameOver obrazovka
            this._gameOver = new GameOver(this._screen);

            // Tlacitko audio ON/OFF
            this._btnAudio = this.createButton([eAtlas_0.btnAudioOff_0, eAtlas_0.btnAudioOff_1, eAtlas_0.btnAudioOn_0, eAtlas_0.btnAudioOn_1], "btnAudio", 72, 72);
            this._btnAudio.setLocalPosition(-10, -10, 0);
            this._btnAudio.button.on("click", this.handleClickAudioBtn, this);

            // Tlacitko "invite"
            this._btnInvite = this.createButton([eAtlas_0.btnInvite_0, eAtlas_0.btnInvite_1], "btnInvite", 72, 72);
            this._btnInvite.setLocalPosition(-90, -10, 0);
            this._btnInvite.button.on("click", this.handleClickInviteBtn, this);
        }

        //this._debugOutput = new DebugOutput(this._screen, 10, -10, 20, Game.APP.assets.find(eFontAsset.default, pc.eAssetType.font).id, 24);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showScorePopup(x: number, y: number, z: number, text: string): void {
        (<ScorePopup>this._scorePopups.activateItem()).show(x, y, z, text);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._scorePopups.update();

        if (this._tutorial.active)
            this._tutorial.update();
    }

    private static readonly STATE_FLAG_TUTORIAL = 1;
    private static readonly STATE_FLAG_MENU_BUTTONS = 2;
    private static readonly STATE_FLAG_SCORE = 4;
    private static readonly STATE_FLAG_GAME_OVER = 8;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    setState(state: eHUDState): void {
        if (state == this._state)
            return;

        this._state = state;

        let flags = 0;

        switch (state) {
            case eHUDState.tutorial: {
                flags = HUD.STATE_FLAG_MENU_BUTTONS | HUD.STATE_FLAG_TUTORIAL;
                break;
            }
            case eHUDState.gameplay: {
                flags = HUD.STATE_FLAG_SCORE;
                break;
            }
            case eHUDState.gameOver: {
                flags = HUD.STATE_FLAG_MENU_BUTTONS | HUD.STATE_FLAG_GAME_OVER;
            }
        }

        // Skore        
        if ((this._score.enabled = (flags & HUD.STATE_FLAG_SCORE) != 0)) {
            this._score.element.text = Player.instance.score.value.toString();
        }

        // Tlacitko pro audio on/off
        if (this._btnAudio) {
            if ((flags & HUD.STATE_FLAG_MENU_BUTTONS) != 0) {
                this.setAudioBtnContent();
                this._btnAudio.enabled = true;
                this._btnInvite.enabled = true;
            }
            else {
                this._btnAudio.enabled = false;
                this._btnInvite.enabled = false;
            }
        }

        // Ukazka ovladani
        if ((flags & HUD.STATE_FLAG_TUTORIAL) != 0) {
            this._tutorial.show();
            this._scorePopups.reset();
        }
        else {
            this._tutorial.reset();
        }

        // GameOver
        if (this._gameOver) {
            if ((flags & HUD.STATE_FLAG_GAME_OVER) != 0)
                this._gameOver.show();
            else
                this._gameOver.reset();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createButton(frameKeys: string[], assetKey: string, w: number, h: number): pc.Entity {
        let atlas = Game.getTextureAtlas(0);
        let sprite = new pc.Sprite(Game.app.graphicsDevice, {
            atlas: atlas,
            frameKeys: frameKeys,
            pixelsPerUnit: 1,
            renderMode: pc.SPRITE_RENDERMODE_SIMPLE
        });

        let spriteAsset = new pc.Asset(assetKey, pc.eAssetType.sprite, { url: "" });
        spriteAsset.resource = sprite;
        spriteAsset.loaded = true;

        Game.app.assets.add(spriteAsset);

        let btn = new pc.Entity();

        btn.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            width: w,
            height: h,
            anchor: [1, 1, 1, 1],
            pivot: [1, 1],
            useInput: true,
            spriteAsset: spriteAsset.id,
            spriteFrame: 0
        });

        btn.addComponent(pc.eCompomentType.button, {
            active: true,
            imageEntity: btn,
            transitionMode: pc.BUTTON_TRANSITION_MODE_SPRITE_CHANGE,
            inactiveSpriteAsset: spriteAsset,
            hoverSpriteAsset: spriteAsset,
            pressedSpriteAsset: spriteAsset,
        });

        this._screen.addChild(btn);

        btn.button.hoverSpriteFrame = 0;
        btn.button.pressedSpriteFrame = 1;
        btn.button.on("mousedown", (event: pc.MouseEvent) => { event.event.stopImmediatePropagation(); });
        btn.button.on("touchstart", (event: pc.TouchEvent) => { event.event.stopImmediatePropagation(); });

        return btn;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleClickAudioBtn(event: Event): void {
        if (Game.sdk.getAdState(eAdMode.videoReward) == eAdState.playing || Game.sdk.getAdState(eAdMode.videoSkippable) == eAdState.playing)
            return;

        if ((SoundManager.mute = !SoundManager.mute)) {
            SoundManager.playSound(Player.instance.entity, eAudioAsset.music);
            SaveState.audioEnabled = false;
        }
        else {
            SoundManager.stop();
            SaveState.audioEnabled = true;
        }

        this.setAudioBtnContent();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setAudioBtnContent(): void {
        let audioState = SoundManager.mute ? 0 : 1;
        let btn = this._btnAudio.button;

        (<any>btn)["_defaultSpriteFrame"] = audioState * 2;
        btn.hoverSpriteFrame = audioState * 2;
        btn.pressedSpriteFrame = audioState * 2 + 1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleClickInviteBtn(event: Event): void {
        if (Game.sdk.getAdState(eAdMode.videoReward) == eAdState.playing || Game.sdk.getAdState(eAdMode.videoSkippable) == eAdState.playing)
            return;

        Game.sdk.showInvite("Попробуй эту игру!");
    }
}